var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightbulbSolid1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 48,
    viewBox: "0 0 35 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3255_11482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7917 35.75C25.6667 32.8217 27.4805 30.3248 29.2761 27.8371C29.75 27.1854 30.224 26.5336 30.6797 25.8727C32.4844 23.2564 33.5417 20.0895 33.5417 16.6654C33.5417 7.73359 26.3594 0.5 17.5 0.5C8.64064 0.5 1.45834 7.73359 1.45834 16.6562C1.45834 20.0803 2.51564 23.2564 4.32032 25.8635C4.77605 26.5244 5.25001 27.1762 5.72397 27.8279C7.52866 30.3156 9.34246 32.8217 10.2083 35.7408H24.7917V35.75ZM17.5 47.5C21.5287 47.5 24.7917 44.2137 24.7917 40.1562V38.6875H10.2083V40.1562C10.2083 44.2137 13.4714 47.5 17.5 47.5ZM10.2083 16.6562C10.2083 17.4641 9.55209 18.125 8.75001 18.125C7.94793 18.125 7.29168 17.4641 7.29168 16.6562C7.29168 10.974 11.8581 6.375 17.5 6.375C18.3021 6.375 18.9583 7.03594 18.9583 7.84375C18.9583 8.65156 18.3021 9.3125 17.5 9.3125C13.4714 9.3125 10.2083 12.5988 10.2083 16.6562Z",
    fill: "#8DAF61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3255_11482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 47,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulbSolid1);
export default __webpack_public_path__ + "static/media/lightbulb-solid 1.96ee17cb41108eec460feef9269537ee.svg";
export { ForwardRef as ReactComponent };